import Phaser from "phaser";
import Boot from "./view/boot";
import Preload from "./view/preload";
import Login from "./view/login";
import SignUp from "./view/sign-up";
import SendEmail from "./view/send-email";
import ResetPassword from "./view/reset-password";
import Menu from "./view/menu";
import Intro from "./view/intro";
import Categories2 from "./view/categories2";
import Categories3 from "./view/categories3";
import Categories4 from "./view/categories4";
import Categories5 from "./view/categories5";
import Categories6 from "./view/categories6";
import Board from "./view/board";
import Rules from "./view/rules";
import Questions from "./view/questions";
import Pause from "./view/pause";
import End from "./view/end";

const config = {
  type: Phaser.CANVAS,
  width: 768,
  height: 1024,
  scene: [
    Boot,
    Preload,
    Login,
    SignUp,
    SendEmail,
    ResetPassword,
    Menu,
    Intro,
    Categories2,
    Categories3,
    Categories4,
    Categories5,
    Categories6,
    Rules,
    Board,
    Questions,
    Pause,
    End,
  ],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  parent: "divId",
  dom: {
    createContainer: !0,
  },
};

export default new Phaser.Game(config);
